import React from 'react';
import { motion } from 'framer-motion';
import { getAdventureTaskImageSrc, type LockedAdventureCardModel } from '../../../utils/adventurePresentation';

interface LockedAdventureCardProps {
  card: LockedAdventureCardModel;
}

export const LockedAdventureCard: React.FC<LockedAdventureCardProps> = ({ card }) => {
  const imageSrc = getAdventureTaskImageSrc(card.title);

  return (
    <motion.article
      data-testid="locked-adventure-card"
      whileHover={{ y: -2 }}
      className="rounded-[28px] border border-slate-200 bg-[linear-gradient(180deg,#f8fafc,#f1f5f9)] p-6 opacity-80 shadow-sm"
    >
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="inline-flex rounded-full bg-slate-200 px-3 py-1 text-xs font-bold text-slate-500">未开放</p>
          <h3 className="mt-3 text-xl font-black text-slate-500">{card.title}</h3>
          <p className="mt-2 text-sm leading-6 text-slate-400">{card.teaser}</p>
        </div>
        <div className="flex flex-col items-end gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white text-2xl text-slate-400 shadow-inner">
            🔒
          </div>
          {imageSrc ? (
            <div className="relative overflow-hidden rounded-[22px] border border-white/70 bg-white shadow-inner">
              <img
                src={imageSrc}
                alt={`${card.title}任务缩略图`}
                loading="lazy"
                className="h-24 w-24 object-cover grayscale"
              />
              <div className="pointer-events-none absolute inset-0 bg-slate-100/45" />
            </div>
          ) : null}
        </div>
      </div>

      <div className="mt-5 flex items-center gap-3">
        {Array.from({ length: 4 }).map((_, index) => (
          <div
            key={index}
            className="flex h-12 w-12 items-center justify-center rounded-2xl border border-slate-200 bg-slate-100 text-slate-300"
          >
            ☆
          </div>
        ))}
      </div>

      <div className="mt-5 rounded-full border border-slate-200 bg-white px-4 py-3 text-center text-sm font-semibold text-slate-400">
        {card.status}
      </div>
    </motion.article>
  );
};
